// frontend/src/components/Sidebar.js
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaHome, FaBox, FaCalculator, FaList, FaUsers, 
  FaSms, FaCog, FaTruck, FaChartBar, FaBoxOpen, 
  FaGlobe, FaImage, FaStar, FaServicestack, FaPhone,
  FaFileAlt, FaBell
} from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import '../styles/admin.css';

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const { user } = useAuth();
  
  // Эрх шалгах функц
  const hasPermission = (permission) => {
    if (!user || !Array.isArray(user.perms)) return false;
    // System admin бол бүх эрхтэй
    if (user.role === 'system_admin') return true;
    return user.perms.includes(permission);
  };

  const isActive = (path) => {
    const fullPath = `/admin/${path}`;
    return location.pathname === fullPath || location.pathname.startsWith(fullPath + '?');
  };

  // Цэс дээр дарахад хаах
  const handleMenuClick = () => {
    if (onClose && window.innerWidth <= 768) {
      onClose();
    }
  };

  // Цэсний бүтэц - эрх шалгалттай
  const menuStructure = useMemo(() => [
    {
      section: 'main',
      title: null,
      items: [
        {
          path: 'dashboard',
          icon: FaHome,
          label: 'Дашбоард',
          show: true // Бүгд харна
        }
      ]
    },
    {
      section: 'core',
      title: 'Үндсэн модулиуд',
      items: [
        {
          path: 'containers',
          icon: FaTruck,
          label: 'Чингэлэг удирдлага',
          show: hasPermission('container:view')
        },
        {
          path: 'cargo',
          icon: FaBoxOpen,
          label: 'Ачаа удирдлага',
          show: hasPermission('cargo:view') || hasPermission('cargo:create')
        },
        {
          path: 'payment',
          icon: FaCalculator,
          label: 'Тайлан тооцоо',
          show: hasPermission('payment:view') || hasPermission('payment:view-all')
        },
        {
          path: 'categories',
          icon: FaList,
          label: 'Ангилал удирдлага',
          show: hasPermission('categories:view')
        }
      ]
    },
    {
      section: 'website',
      title: 'Вэбсайт удирдлага',
      items: [
        {
          path: 'banners',
          icon: FaImage,
          label: 'Баннер удирдлага',
          show: hasPermission('website:view')
        },
        {
          path: 'client-features',
          icon: FaStar,
          label: 'Давуу тал',
          show: hasPermission('website:view')
        },
        {
          path: 'client-services',
          icon: FaServicestack,
          label: 'Үйлчилгээ',
          show: hasPermission('website:view')
        },
        {
          path: 'cargo-requests',
          icon: FaBell,
          label: 'Ачаа дуудлага',
          show: hasPermission('website:view')
        },
        {
          path: 'client-contact',
          icon: FaPhone,
          label: 'Холбоо барих',
          show: hasPermission('website:view')
        }
      ]
    },
    {
      section: 'other',
      title: 'Бусад',
      items: [
        {
          path: 'users',
          icon: FaUsers,
          label: 'Хэрэглэгч удирдлага',
          show: hasPermission('users:view')
        },
        {
          path: 'sms',
          icon: FaSms,
          label: 'SMS удирдлага',
          show: hasPermission('sms:view')
        },
        {
          path: 'settings',
          icon: FaCog,
          label: 'Тохиргоо',
          show: hasPermission('settings:view')
        }
      ]
    }
  ], [user]);

  return (
    <div className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-content">
        <ul className="sidebar-menu">
          {menuStructure.map((section) => {
            // Эрхтэй цэсүүдийг шүүх
            const visibleItems = section.items.filter(item => item.show);
            
            // Хэрэв section-д харагдах цэс байхгүй бол бүхэлдээ нуух
            if (visibleItems.length === 0) return null;

            return (
              <React.Fragment key={section.section}>
                {/* Section title */}
                {section.title && (
                  <li className="sidebar-divider">
                    <span className="sidebar-divider-text">{section.title}</span>
                  </li>
                )}

                {/* Menu items */}
                {visibleItems.map((item) => (
                  <li key={item.path}>
                    <Link 
                      to={`/admin/${item.path}`}
                      className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
                      onClick={handleMenuClick}
                    >
                      <item.icon className="sidebar-icon" />
                      <span className="sidebar-text">{item.label}</span>
                    </Link>
                  </li>
                ))}
              </React.Fragment>
            );
          })}

          {/* Гадаад линк - дэлгэцийн хамгийн доор */}
          <li>
            <a 
              href="https://old.jimguntrade.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="sidebar-item"
              onClick={handleMenuClick}
            >
              <FaGlobe className="sidebar-icon" />
              <span className="sidebar-text">Хуучин вэб</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}